module.exports = "/_next/static/images/SANTAI_MSIG-348a5c0f9f2fcaf1159984a65af5ef91.svg";